<template>
  <div class="container">
    <section>
      <h5>Les règles</h5>
      <p class="mb-5">
        C'est à partir des règles que le système génère des suggestions pour le
        participant lorsqu'il joint la délibération.
      </p>
      <p>
        Voici les annonces qui apparaissent sur la page d'accueil du participant
        :
      </p>
      <ol class="list-unstyled">
        <li>
          1 - S'il a écrit une publication dans la délibération et qu'il a reçu
          des réponses, le participant verra cette discussion.
        </li>
        <li>2- Ses notifications, auquel il pourra répondre directement.</li>
      </ol>
    </section>
    <section>
      <h5>Analytiques</h5>
      <p>
        Les analytiques permettent de générer des statistiques sur chaque
        participant lors de son évaluation :
      </p>
      <p>
        <strong class="pr-2">Partisanerie.</strong> Le nombre d'interventions en
        faveur de l'idée principale vs le nombre d'interventions qui s'y
        opposent.
      </p>
      <p>
        <strong class="pr-2">Curiosité.</strong> Le nombre d'interventions lues
        vs le nombre d'interventions publiées.
      </p>
      <p>
        <strong class="pr-2">Engagement.</strong> Réponses à ses notifications.
      </p>
      <p>
        <strong class="pr-2">Diversité de sources.</strong> Le nombre de sources
        distinctes vs le nombre d'interventions publiées
      </p>
      <p>
        <strong class="pr-2">Richesse.</strong> Le nombre de publications créées
        par l'étudiant vs le nombre de commentaires qu'il propose pour soutenir
        celles-ci.
      </p>
      <p><strong class="pr-2">Rigueur.</strong> Le nombre de sources citées.</p>
    </section>
    <section>
      <h5>
        Suggestions automatiques pendant la participation à la délibération
      </h5>
      <p>
        Ces règles permettront d'afficher des suggestions aux moments déterminés
        pour aider les participants. Les enseignants auront l'option d'activer
        toutes les règles ou certaines seulement dans les paramètres avancés de
        chaque délibération.
      </p>
      <b-table
        class="my-5"
        :items="rules.data.data"
        :fields="fields"
        bordered
        stacked="md"
        fixed
      >
        <template v-slot:cell(condition)="row">
          <span v-html="formatCondition(row.value)"></span>
        </template>
        <template v-slot:cell(notification)="row">
          <b-input-group>
            <b-form-textarea
              class="border-0"
              :value="row.value"
              no-resize
              rows="3"
              max-rows="20"
              @change="
                onChangeNotification({
                  id: row.item.id,
                  notification: $event
                })
              "
            ></b-form-textarea>
            <b-input-group-append>
              <b-input-group-text class="bg-transparent p-2 border-0">
                <img
                  src="@/assets/img/u3587.png"
                  class="d-inline-block align-center"
                />
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div v-if="row.item.id == 2" class="text-info">[lien].</div>
          <div v-if="row.item.id == 3">
            <span class="text-success">« Parce que »</span>,
            <span class="text-danger">« Par contre »</span> <br />ou
            <span class="text-purple">« Donc »</span>
          </div>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
/**
 * @file       Rules component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { mapState } from "vuex";
import store from "@/store";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  /**
   * Before route change.
   * 
   * @param  {string}   to     (Unused)
   * @param  {string}   from   (Unused)
   * @param  {Object}   next   The action
   */
  beforeRouteEnter(to, from, next) {
    store.dispatch("teachers/getConfig").then(() => next());
  },

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      fields: [
        { key: "objective", label: "But" },
        { key: "condition", label: "Condition" },
        { key: "notification", label: "Suggestion affichée au participant" },
        { key: "preview", label: "Prévisualisation" }
      ]
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      rules: state => state.teachers.config
    })
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Format condition.
     * 
     * @param   {String}    The string to format
     * 
     * @return   {String}   The formatted string
     */
    formatCondition(text) {
      let format = text.split(",").shift();
      return text.replace(format.trim(), `<u>${format}</u>`);
    },

    /**
     * Change notification.
     * 
     * @param   {Object}    The config
     */
    onChangeNotification(payload) {
      store
        .dispatch("teachers/putConfig", payload)
        .then(() => {
          this.$root.$bvToast.toast(`Règle mise à jour avec succès`, {
            title: "Succès"
          });
        })
        .catch(() => {
          this.$root.$bvToast.toast("La mise à jour de la règle à échoué", {
            title: "Erreur",
            variant: "danger"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-control:focus {
  border-color: transparent !important;
  padding-left: 5px;
  color: #212529;
}

td textarea {
  box-shadow: none;
  padding-left: 5px;
  overflow-y: hidden !important;
  color: #212529;
}
</style>
